import axios from "axios";
import { loadShmupsActionCreator } from "../features/shmupsSlice";

const shmupsListThunk = async (dispatch) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}shmups/list`;
    const {
      data: { shmups },
    } = await axios.get(url);
    dispatch(loadShmupsActionCreator(shmups));
  } catch {
    console.log("something gone wrong");
  }
};

export default shmupsListThunk;
